import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
// import { Image } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../../styles';
import ButtonSet from '../../ButtonSet';

const styles = css`
  .ProductCards3by2 {
    overflow: hidden;
    position: relative;
    background-color: ${colors.white};
    @media (min-width: 768px) {
      padding: 15px 0 150px 0;
    }
  }
  .ProductCards3by2_card_list {
    @media (min-width: 992px) {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: space-around;
    }
  }
  .ProductCards3by2_card_item {
    margin: 0 0 4px 0;
    position: relative;
    height: 540px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;
    ::after {
      content: '';
      display: block;
      position: absolute;
      z-index: 1;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background: linear-gradient(149.58deg, rgba(92,178,193,0) 0%, #104271 100%);
    }
    @media (min-width: 992px) {
      width: calc(50% - 4px);
      height: 715px;
      margin: 0 0 4px 0;
      :nth-of-type(-n+3) {
        width: calc(33.3333% - 4px);
      }
    }
  }
  .ProductCards3by2_card_item_image {
    height: 100%;
  }
  .ProductCards3by2_card_item_text {
    padding: 40px;
    z-index: 2;
    position: absolute;
    bottom: 10px;
    left: 0px;
    @media (min-width: 992px) {
      padding: 0 10px 0 0;
    }
    @media (min-width: 1400px) {
      bottom: 30px;
      left: 60px;
      padding: 0 60px 100px 0;
    }
    h3 {
      color: ${colors.white};
      font-weight: 700;
      font-size: 29px;
      text-transform: uppercase;
      text-align: center;
      ::after {
        content: '';
        display: block;
        margin: 15px auto 15px auto;
        width: 75px;
        height: 2px;
        background-color: ${colors.brand3};
        @media (min-width: 992px) {
          margin: 20px auto 20px auto;
        }
        @media (min-width: 1400px) {
          margin: 25px auto 25px auto;
        }
      }
    }
    p {
      font-family: ${typography.Condensed};
      color: ${colors.white};
      font-weight: 400;
      vertical-align: bottom;
      margin: 0 0 25px 0;
      font-size: 18px;
      text-align: center;
    }
  }
  .ProductCards3by2_card_item_iconCircle {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background-color: ${colors.brand5};
    margin: 0 auto 45px auto;
    display: flex;
    justify-content: center;
    @media (min-width: 992px) {
      width: 120px;
      height: 120px;
    }
    img {
      margin: auto auto;
    }
  }
  .btn-brand2 {
    background-color: ${colors.white};
    border: 2px solid ${colors.white};
  }
`;

function ProductCards3by2({ content }) {
  return (
    <div className={styles}>
      <div className="ProductCards3by2">
        <div className="d-lg-flex flex-lg-column">
          <div className="ProductCards3by2_card_list">
            {
              get(content, '[0]card_list').map(item => (
                <div className="ProductCards3by2_card_item" style={{ backgroundImage: `url(${get(item, 'image.contentUrl')})` }} key={item._id}>
                  {/* <Image
                    className="ProductCards3by2_card_item_image"
                    src={get(item, 'image.contentUrl')}
                    width={1000}
                    height={1000}
                    alt={get(item, 'image.name', get(item, 'image.caption'))}
                  /> */}
                  <div className="ProductCards3by2_card_item_text">
                    <div className="ProductCards3by2_card_item_iconCircle">
                      <img src={get(item, 'icon.contentUrl')} alt="icon" />
                    </div>
                    <h3>{get(item, 'title')}</h3>
                    <p>{get(item, 'body')}</p>
                    <ButtonSet buttonSetParent={item} />
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

ProductCards3by2.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

ProductCards3by2.defaultProps = {
};

export const sectionName = 'Home Conent';

export default ProductCards3by2;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/ProductCards3by2.section.js